/**
 * Places ladder — how many finishing positions "pay" for a given field size.
 *
 * SportsBet and Ladbrokes publish identical standard place rules (see
 * docs/LEXI-PERFORMANCE-REPORTS-SPEC.md §3):
 *   8+ runners → top 3 · 5–7 runners → top 2 · <5 runners → win only
 *
 * The variation punters actually see lives in Same Race Multi (pick top 2/3/4)
 * and one-off promos, so the control we expose is a Top-N "lens", not a bookie
 * name. Extra ladders (promo/bookie-specific) can be keyed into LADDERS later.
 */

export const LADDERS = {
  standard: [
    { min: 8, places: 3 },
    { min: 5, places: 2 },
    { min: 1, places: 1 },
  ],
};

/**
 * @param {number} fieldSize - runners in the race (use field at market close).
 * @param {{lens?: string, ladder?: string}} [opts]
 *   lens: "auto" (by field size) or a Top-N override ("top2"/"top3"/"top4" or 2/3/4).
 *   ladder: key into LADDERS (default "standard").
 * @returns {number} number of positions that pay.
 */
export function placesPaid(
  fieldSize,
  { lens = "auto", ladder = "standard" } = {},
) {
  // Explicit Top-N lens overrides the field-size ladder.
  if (lens && lens !== "auto") {
    const n = Number(String(lens).replace(/[^0-9]/g, ""));
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  const table = LADDERS[ladder] || LADDERS.standard;
  const size = Number(fieldSize) || 0;
  const tier = table.find((t) => size >= t.min);
  return tier ? tier.places : 1;
}
